import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import { Button } from "reactstrap";
import "./package-form.css";
const choices = [{
  value: "package",
  title: "Package",
  icon: "ri-calendar-line",
  description: "Detailed screening package with accordion sections (procedures, lab tests, radiology) and specialist carousel."
}, {
  value: "informative",
  title: "Informative",
  icon: "ri-image-line",
  description: "Promotional package with image popup, file or external link. Used for bank privileges, partner promotions and limited-time offers."
}, {
  value: "privilege",
  title: "Privilege",
  icon: "ri-share-box-line",
  description: "Associate doctor programme or privilege registration with a long-form application, family particulars and consent."
}];
export default function PackageTypeDialog({ onClose, onProceed }) {
  const [selected, setSelected] = useState("package");
  return <Dialog open onClose={onClose} fullWidth maxWidth="md" className="package-type-dialog">
    <DialogTitle>Select package type</DialogTitle>
    <IconButton
      aria-label="Close package type selection" onClick={onClose}
      sx={{
        position: "absolute",
        top: 20,
        right: 20
      }}
    >
      <i className="ri-close-line" />
    </IconButton>
    <DialogContent dividers>
      <p>Choose the type of package you want to add.</p>
      <Stack role="group" aria-label="Package type" spacing={1.5}>{choices.map(choice => <Stack
          type="button"
          className={`package-type-choice${selected === choice.value ? " is-selected" : ""}`}
          key={choice.value} aria-pressed={selected === choice.value}
          onClick={() => setSelected(choice.value)} component="button" direction="row"
          alignItems="flex-start" gap={2}
        >
          <i className={choice.icon} />
          <Stack component="span" gap={0.5}>
            <strong>{choice.title}</strong>
            <span>{choice.description}</span>
          </Stack>
        </Stack>)}</Stack>
    </DialogContent>
    <DialogActions>
      <Button color="light" onClick={onClose}>Cancel</Button>
      <Button color="primary-button" onClick={() => onProceed(selected)}>Proceed to create package</Button>
    </DialogActions>
  </Dialog>;
}
